<template>
  <div class="drug-container container">
    <span class="basic-title">急救措施及用药：</span>
    <drug-edit
      v-if="!isShowPatient"
      ref="editRef"
      class="drug-info substance"
    />
    <drug-look
      v-else
      class="drug-info substance"
    />
  </div>
</template>
<script>
import DrugEdit from "@/components/patients/drugs/DrugEdit";
import DrugLook from "@/components/patients/drugs/DrugLook";
import { mapState } from "vuex";

export default {
  name: "Drug",
  components: {
    DrugLook,
    DrugEdit
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    isShowPatient() {
      return this.patient?.pageInfo?.isShowPatient;
    },
    showOperation() {
      return this.patient?.operationM;
    },
  },
};
</script>

<style lang="scss" scoped>
.drug-info {
  padding-top: 12px; // 分区信息标题(已经缩了12px了)

}
</style>
